import { create } from 'zustand';

type linkState = {
  data: string;
  setLinkData: (data: string) => void;
};

export const useLinkStore = create<linkState>((set, get) => ({
  data: '',
  setLinkData: data => set(() => ({ data: data })),
  action: () => {
    const data = get().data;
  },
}));
